import { Component } from '@angular/core';

@Component({
  selector: 'information-modal-svg',
  templateUrl: './information-modal.component.svg',
})
export class InformationModalComponent {}
